// extracted by mini-css-extract-plugin
module.exports = {"container":"v_detail_schedule_container__2vKUP","title":"v_detail_schedule_title__TICch","tags_container":"v_detail_schedule_tags_container__1IGXx"};